import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { supabase } from '../lib/supabase';
import { ApiError, INSUFFICIENT_CREDITS } from '@superlekcja/shared';

// Adres wzgledny w OBU srodowiskach. W dev requesty przechodza przez proxy `/api` z
// vite.config.ts, ktore po stronie serwera trafia do backendu na localhost:3000.
//
// Wczesniej dev mial tu adres bezwzgledny 'http://localhost:3000/api'. Dzialalo to wylacznie
// wtedy, gdy przegladarka stala na tej samej maszynie co backend: przy wejsciu z innego
// urzadzenia 'localhost' oznacza URZADZENIE ODWIEDZAJACEGO, wiec kazdy request wisial do
// timeoutu, a strona zostawala na spinnerze mimo dzialajacego API.
export const baseURL = '/api';
export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Authentication helper functions
export async function getAuthToken(): Promise<string | null> {
    // Wait for the session to be initialized
    const { data: { session } } = await supabase.auth.getSession();
    return session?.access_token ?? null;
  }

// Jezyk interfejsu — od TASK-57 zawsze polski. Wczesniej czytany z localStorage; klucza nikt
// juz nie zapisuje, wiec czytanie go oznaczaloby tylko, ze uzytkownik z zapisanym 'en' dostaje
// angielskie etykiety materialow w polskim UI.
export function getCurrentLanguage(): string {
  return 'pl';
}
  

// Add request interceptor to add auth token and language header
api.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      try {
        const token = await getAuthToken();
        const language = getCurrentLanguage();
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        // Always add language header
        config.headers['Accept-Language'] = language;
        
        return config;
      } catch (error) {
        console.error('Error getting auth token:', error);
        return Promise.reject(error);
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Add response interceptor to handle auth errors
  api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        // Just log the unauthorized error without signing out
        console.error('Unauthorized request:', error);
      }
      return Promise.reject(error);
    }
  );
  
  
  
  // Type guard for API error response
  export function isApiError(response: unknown): response is ApiError {
    return (response as ApiError)?.status === 'error';
  }
  // Re-exported from @superlekcja/shared so backend and frontend share ONE
  // literal and can't drift. Existing imports of `INSUFFICIENT_CREDITS` from
  // this module keep working unchanged.
  export { INSUFFICIENT_CREDITS }
